import { EffectiveState } from '@/gen/marketDataApi'

import { cn } from '@/utils/cn'

import { StatusCircle } from '../statusCircle'
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip'

interface Props {
    className?: string
    state: EffectiveState
}

const circles = {
    Open: <StatusCircle variant="success" />,
    Down: <StatusCircle variant="destructive" />,
    Enquiry: <StatusCircle variant="outline" />,
    Auction: <StatusCircle variant="secondary" />,
    Adjust: <StatusCircle variant="warning" />,
}

export default function EffectiveStateCircle({ className, state }: Props) {
    const Cmp = circles[state]
    return (
        <Tooltip>
            <TooltipTrigger>
                <div className={cn(className)}>{Cmp}</div>
            </TooltipTrigger>
            <TooltipContent>{state}</TooltipContent>
        </Tooltip>
    )
}
